module.exports = __webpack_public_path__ + "static/media/aplication1.6f506229.png";